import React from "react";
import { Button, Input, Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { convertBlobToBase64Url } from "../utils/binaryHelper";

import CircularProgress from "@mui/material/CircularProgress";

interface UploadFileProps {
  id: string;
  accept?: string;
  onChange: (
    selectedFile: string,
    fileName: string,
    mimeType: string,
    size: number
  ) => void;
}

export function UploadFileButton(props: UploadFileProps) {
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [dataFile, setDataFile] = React.useState<File[] | null>(null);
  const [pageState, setPageState] = React.useState<string>("none");
  const [isConverting, setIsConverting] = React.useState<boolean>(false);

  async function handleClose() {
    setOpenDialog(false);
  }

  async function saveFile() {
    const fileCount = dataFile?.length ?? 0;
    let fileAsString = '';
    let dataSize = 0;
    let fileName = '';
    let fileType = '.csv';
    for(let i = 0; i < fileCount; i++) {

      const currentFile = dataFile?.at(i);
      if (currentFile) { 
        const file = (await convertBlobToBase64Url(currentFile)) as string;
        fileName = currentFile.name;
        let tag = "[DATA]";
        if (currentFile.name.toLowerCase().indexOf('seed') >= 0) {
          tag = '[SEED]';
        }
        fileAsString += tag + file ;
        dataSize += currentFile.size;
        fileType = currentFile.type;
      }
    }
   
    setIsConverting(true);
    console.log(`about to convert file to base 64`);
   
    setIsConverting(false);
    console.log(`calling parent method`);
    props.onChange(fileAsString, fileName, fileType, dataSize);

    setOpenDialog(false);
  }

  function isState(state: string): boolean {
    return state === pageState;
  }

  const onFileSelected = async ({ target }: any) => {
    try {
      const array = [] as File[];
      for (let i = 0; i < target.files.length; i++) { 
        const currentFile = target.files[i] as File;
        array.push(currentFile);
      }

      setDataFile(array);
      setPageState("fileSelected");
      setOpenDialog(true);
      target.value = null;
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <>
      <Grid>
        <Grid item xs={3}>
          <label htmlFor={props.id}>
            <Input
              id={props.id}
              sx={{ display: "none" }}
              inputProps={{ accept: props.accept, multiple: true }}
              type="file"
              onChange={onFileSelected}
            />
            <Button color="secondary" variant="contained" component="span">
              Import
            </Button>
          </label>
        </Grid>
      </Grid>

      <Dialog open={openDialog} sx={{ width: 1000 }}>
        <DialogTitle>Upload Document</DialogTitle>

        <DialogContent sx={{ width: 500 }}>
          {isConverting && <CircularProgress />}
          {!isConverting && dataFile && (
            <p> fileName : '{dataFile[0].name.substring(0, 30)} </p>
          )}
        </DialogContent>

        <DialogActions>
          {isState("fileSelected") && (
            <Button onClick={saveFile}>Upload</Button>
          )}
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
